export { getMediaReadCredentialsEpic } from './epic';
